import { TOP_DEBUT_TITLES } from '../../../core/constants';
import BookstatListTab from './BookstatListTab';
import { acquisitionRowActions } from './digestRowActions';

const renderActions = acquisitionRowActions(TOP_DEBUT_TITLES);

const TopDebutTitles = () => <BookstatListTab id={TOP_DEBUT_TITLES} renderActions={renderActions} />;

export default TopDebutTitles;
